import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
      margin: 0;
      font-family: 'Poppins', 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      position:relative;
      background: ${(props) => props.theme['Surface/page']};
      color: ${(props) => props.theme['Content/primary']};
      font-size: 14px;
  }

  * {
      /* Firefox */
      scrollbar-width: thin;
      scrollbar-color: ${(props) => props.theme['Borders/quiet']} transparent;
  }

  /* Chrome, Edge, Safari */
  *::-webkit-scrollbar {
      width: 8px;
      height: 8px;
  }

  *::-webkit-scrollbar-track {
      background: transparent;
  }

  *::-webkit-scrollbar-thumb {
      background-color: ${(props) => props.theme['Borders/quiet']};
      border-radius: 4px;
  }

  *::-webkit-scrollbar-thumb:hover {
      background-color: ${(props) => props.theme['Borders/hover']};
  }

  *::-webkit-scrollbar-corner {
      background: transparent;
  }
  
   body input:-webkit-autofill,
    body input:-webkit-autofill:hover,
    body input:-webkit-autofill:focus,
    body input:-webkit-autofill:active,
    body textarea:-webkit-autofill,
    body textarea:-webkit-autofill:hover,
    body textarea:-webkit-autofill:focus,
    body textarea:-webkit-autofill:active {
        -webkit-text-fill-color: ${(props) => props.theme['Content/primary']} !important;
        color: ${(props) => props.theme['Content/primary']} !important;

        -webkit-box-shadow: 0 0 0px 1000px ${(props) => props.theme['Surface/page']} inset !important;
        box-shadow: 0 0 0px 1000px ${(props) => props.theme['Surface/page']} inset !important;

        transition: background-color 9999s ease-in-out 0s, color 0s ease-out 0s, -webkit-text-fill-color 0s ease-out 0s !important;
    }

    body input:-webkit-autofill::first-line {
        -webkit-text-fill-color: ${(props) => props.theme['Content/primary']} !important;
        color: ${(props) => props.theme['Content/primary']} !important;
    }

  .ant-table-wrapper .ant-table-sticky-holder {
      background: transparent;
  }

  .ant-table-wrapper .ant-table-tbody > tr > td.ant-table-cell-row-hover,
  .ant-table-wrapper .ant-table-tbody > tr:hover > td {
      background: ${(props) => props.theme['Surface/secondary']} !important;
  }

  .table-action-dropdown .ant-dropdown-menu {
      background-color: ${(props) => props.theme['Surface/page']} !important;
      border-radius: 0;
      border: 1px solid ${(props) => props.theme['Borders/quiet']} !important;
      box-shadow: none !important;
  }

  .ant-dropdown-menu-title-content {
      color: ${(props) => props.theme['Content/primary']} !important;
  }
  .table-action-dropdown .ant-dropdown-menu-item {
      background-color: ${(props) => props.theme['Surface/page']} !important;
      

      &:hover {
          background-color: ${(props) => props.theme['Surface/secondary']} !important;
          color: ${(props) => props.theme['Content/primary']} !important;
      }
  }

  /* Only the virtual list inside an antd select popup may scroll. The popup's own
     max-height is 250px while antd sizes the list to 256px, so without this the popup
     overflows by a few pixels and grows a second scrollbar beside the list's own. */
  .country-select-popup.ant-select-dropdown,
  .single-scroll-popup.ant-select-dropdown {
      max-height: none !important;
      overflow: visible !important;
  }
`;
